export default __webpack_public_path__ + "static/media/4.Dracula.19dade08.wav";